import { DateInputFormik } from '@strata/react-date-time';
import { DialogWithForm } from '@strata/react-dialog';
import { validationStrings } from '@strata/strata-ui-strings';
import dayjs from 'dayjs';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { handleError } from 'services/ErrorManagement';

export const UpdateEffectiveDateDialog = ({
    isOpen,
    onSubmit,
    onSecondaryButtonClick,
    effectiveDate = undefined,
}) => (
    <Formik
        initialValues={{ effectiveDate }}
        enableReinitialize
        validationSchema={Yup.object({
            effectiveDate: DateInputFormik.validator().required(
                validationStrings.requiredField.errorMessage,
            ),
        })}
        onSubmit={async (values, { resetForm }) => {
            try {
                await onSubmit(dayjs(values.effectiveDate).toISOString());
                resetForm();
                onSecondaryButtonClick();
            } catch (err) {
                handleError('Error updating effective date.', err);
            }
        }}
    >
        {(formik) => (
            <DialogWithForm
                dialogTitle="Update Effective Date"
                primaryButtonLabel="Save"
                secondaryButtonLabel="Cancel"
                isOpen={isOpen}
                onSecondaryButtonClick={() => {
                    formik.handleReset();
                    onSecondaryButtonClick();
                }}
                isPrimaryButtonDisabled={!(formik.dirty && formik.isValid) || formik.isSubmitting}
                dialogContent={
                    <>
                        <p className="margin__bottom--large">
                            Updating the effective date will change the scheduled date when this
                            policy goes into production.
                        </p>
                        <DateInputFormik id="effectiveDate" label="Date" required showTime />
                    </>
                }
            />
        )}
    </Formik>
);

UpdateEffectiveDateDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onSecondaryButtonClick: PropTypes.func.isRequired,
    effectiveDate: PropTypes.string,
};
